import apiUrl from "./config/config";
import axios from "axios";

class userApi {

  //Get all users
  static async getUsers(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "user", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }
  
  //Get one user by id
  static async getUser(id)
  {

    try
    {

      const response = await axios(apiUrl + `user/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Reset Password
  static async resetPassword(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "user/reset", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Reset Password
  static async validateUser(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "user/validate", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }



  //Get current user
  static async getCurrentUser(id)
  {

    try
    {

      const response = await axios(apiUrl + `user/current`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Update current user settings
  static async updateCurrentUser(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "user/current", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }


  //Update user
  static async updateUser(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "user", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

}

export default userApi;
